import React, { forwardRef } from "react";
import InputMask from "react-input-mask";

// Componente InputField padronizado e compacto
const InputField = forwardRef(
  ({ label, name, value, onChange, error, type = "text", ...props }, ref) => (
    <div className="calculate-form appointment-form-3 mb-20">
      <label htmlFor={name}>{label}</label>
      <input
        id={name}
        type={type}
        ref={ref}
        value={value}
        onChange={onChange}
        aria-invalid={error ? "true" : "false"}
        className={`form-control ${error ? "input-error" : ""}`}
        {...props}
      />
      {error && (
        <span role="alert" className="error">
          {typeof error === "string" ? error : error.message}
        </span>
      )}
    </div>
  )
);

// Componente MaskedInputField padronizado e compacto
const MaskedInputField = forwardRef(
  ({ label, name, value, onChange, mask, error, ...props }, ref) => (
    <div className="calculate-form appointment-form-3 mb-20">
      <label htmlFor={name}>{label}</label>
      <InputMask
        id={name}
        mask={mask}
        ref={ref}
        value={value}
        onChange={onChange}
        className={`form-control ${error ? "input-error" : ""}`}
        {...props}
      />
      {error && (
        <span role="alert" className="error">
          {typeof error === "string" ? error : error.message}
        </span>
      )}
    </div>
  )
);

// Componente SelectField padronizado e compacto
const SelectField = forwardRef(
  ({ label, name, value, onChange, error, children, disabled, ...props }, ref) => (
    <div className="calculate-form appointment-form-3 mb-20">
      <label htmlFor={name}>{label}</label>
      <select
        id={name}
        ref={ref}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`form-control form-select ${error ? "input-error" : ""}`}
        {...props}
      >
        {children}
      </select>
      {error && (
        <span role="alert" className="error">
          {typeof error === "string" ? error : error.message}
        </span>
      )}
    </div>
  )
);

// Componente TextareaField padronizado e compacto
const TextareaField = forwardRef(
  ({ label, name, value, onChange, error, rows = 4, ...props }, ref) => (
    <div className="calculate-form appointment-form-3 mb-20">
      <label htmlFor={name}>{label}</label>
      <textarea
        id={name}
        ref={ref}
        value={value}
        onChange={onChange}
        rows={rows}
        className={`form-control ${error ? "input-error" : ""}`}
        {...props}
      />
      {error && (
        <span role="alert" className="error">
          {typeof error === "string" ? error : error.message}
        </span>
      )}
    </div>
  )
);

export { InputField, MaskedInputField, SelectField, TextareaField };
